/* EcoGlam theme.js — drawer + modal toggles, qty controls, wishlist, ticker. */
(function () {
  'use strict';

  // ---- Drawer / modal open + close ----
  function setOpen(el, open) {
    if (!el) return;
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  // Kategorien-Menü (Seitenleiste links, sections/header.liquid)
  function setMenu(open) {
    var drawer = document.querySelector('[data-menu-drawer]');
    if (!drawer) return;
    setOpen(drawer, open);
    var burger = document.querySelector('[data-open="menu"]');
    if (burger) burger.setAttribute('aria-expanded', String(open));
    if (open) {
      var first = drawer.querySelector('.menu-drawer__nav a');
      if (first) first.focus();
    } else if (burger) {
      burger.focus();
    }
  }
  function menuIsOpen() {
    var drawer = document.querySelector('[data-menu-drawer]');
    return !!drawer && drawer.getAttribute('aria-hidden') === 'false';
  }
  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-open]');
    var closeTrigger = e.target.closest('[data-close]');
    if (openTrigger) {
      var k = openTrigger.dataset.open;
      if (k === 'menu') setMenu(true);
      if (k === 'cart') setOpen(document.querySelector('[data-cart-drawer]'), true);
      if (k === 'search') {
        setOpen(document.querySelector('[data-search-modal]'), true);
        var searchField = document.querySelector('[data-search-modal] input[name="q"]');
        if (searchField) searchField.focus();
      }
    }
    if (closeTrigger) {
      var k2 = closeTrigger.dataset.close;
      if (k2 === 'menu') setMenu(false);
      if (k2 === 'cart') setOpen(document.querySelector('[data-cart-drawer]'), false);
      if (k2 === 'search') setOpen(document.querySelector('[data-search-modal]'), false);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (menuIsOpen()) setMenu(false);
      setOpen(document.querySelector('[data-cart-drawer]'), false);
      setOpen(document.querySelector('[data-search-modal]'), false);
    }
  });

  // ---- Real-time cart refresh ----
  function refreshCart(keepOpen) {
    return Promise.all([
      fetch('/?section_id=cart-drawer').then(function (r) { return r.text(); }),
      fetch('/cart.js').then(function (r) { return r.json(); })
    ]).then(function (results) {
      var html = results[0];
      var cart = results[1];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer]');
      var scrim = doc.querySelector('.cart-drawer__scrim');
      var current = document.querySelector('[data-cart-drawer]');
      if (fresh && current) {
        current.replaceWith(fresh);
        var currentScrim = document.querySelector('.cart-drawer__scrim');
        if (!currentScrim && scrim) fresh.after(scrim);
      }
      if (keepOpen) setOpen(document.querySelector('[data-cart-drawer]'), true);
      var badge = document.querySelector('[data-cart-count]');
      if (badge) badge.textContent = cart.item_count;
    }).catch(function () {
      if (keepOpen) setOpen(document.querySelector('[data-cart-drawer]'), true);
    });
  }

  // ---- Add-to-cart (product page + quick-add cards) ----
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#ProductForm, form.quick-add');
    if (!form) return;
    e.preventDefault();
    // Bestellung auf Anfrage: Enter im Formular legt in die Anfrageliste statt in den Warenkorb
    var inquiryBtn = form.querySelector('[data-inquiry-add]');
    if (inquiryBtn) { inquiryBtn.click(); return; }
    var btn = form.querySelector('[data-add-to-cart]');
    var originalText = btn ? btn.textContent.trim() : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form))
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) {
          throw new Error(d.description || d.message || 'Fehler beim Hinzufügen');
        });
        return refreshCart(true).then(function () {
          if (btn) { btn.disabled = false; btn.textContent = originalText; }
        });
      })
      .catch(function (err) {
        if (btn) {
          btn.disabled = false;
          btn.textContent = err.message.length < 60 ? err.message : 'Nicht verfügbar';
          setTimeout(function () { btn.textContent = originalText; }, 3000);
        }
      });
  });

  // ---- Cart qty + remove ----
  var qtyTimer = null;
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      var input = qtyBtn.parentElement.querySelector('[data-qty-input]');
      var newVal = Math.max(1, parseInt(input.value, 10) + parseInt(qtyBtn.dataset.qty, 10));
      input.value = newVal;
      scheduleQtyUpdate(input.dataset.lineKey, newVal);
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rm.dataset.remove, quantity: 0 })
      }).then(function () { return refreshCart(true); });
    }
  });

  function scheduleQtyUpdate(lineKey, quantity) {
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      }).then(function () { return refreshCart(true); });
    }, 400);
  }

  // ---- Wishlist (localStorage) ----
  function getWish() {
    try {
      var raw = JSON.parse(localStorage.getItem('eg.wish') || '[]');
      return raw.map(function (item) { return typeof item === 'string' ? { id: item } : item; });
    } catch (_) { return []; }
  }
  function setWish(arr) { localStorage.setItem('eg.wish', JSON.stringify(arr)); updateWishUI(); }
  function updateWishUI() {
    var ids = getWish().map(function (p) { return p.id; });
    var onWishPage = !!document.querySelector('[data-wish-page]');
    document.querySelectorAll('[data-product-card]').forEach(function (card) {
      var liked = ids.indexOf(card.dataset.productId) !== -1;
      if (liked) card.setAttribute('data-liked', '');
      else card.removeAttribute('data-liked');
    });
    var c = document.querySelector('[data-wish-count]');
    if (c) c.setAttribute('data-n', ids.length);
    // Tell the wishlist page to re-render when an item is toggled
    if (onWishPage) window.dispatchEvent(new Event('eg:wish'));
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish-toggle]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-product-card]');
    var id = card && card.dataset.productId;
    if (!id) return;
    var list = getWish();
    var idx = list.findIndex(function (p) { return p.id === id; });
    if (idx === -1) {
      list.push({
        id: id,
        url: card.dataset.productUrl || '#',
        title: card.dataset.productTitle || '',
        price: card.dataset.productPrice || '',
        sub: card.dataset.productSub || '',
        imageUrl: card.dataset.productImage || ''
      });
    } else {
      list.splice(idx, 1);
    }
    setWish(list);
  });
  updateWishUI();
  // Re-run when browser restores page from back-forward cache (hearts would be stale)
  window.addEventListener('pageshow', function (e) { if (e.persisted) updateWishUI(); });

  // ---- Bestellung auf Anfrage: Anfrageliste (localStorage) statt Warenkorb, z. B. für Polen ----
  // Aktiv, wenn <body data-inquiry-mode> (snippets/inquiry-mode.liquid). Kein Shopify-Warenkorb,
  // also auch kein Checkout: Die Liste wird per WhatsApp oder E-Mail als Anfrage gesendet.
  var INQUIRY_KEY = 'eg.inquiry';
  function getInquiry() {
    try {
      var list = JSON.parse(localStorage.getItem(INQUIRY_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (_) { return []; }
  }
  function setInquiry(list) {
    try { localStorage.setItem(INQUIRY_KEY, JSON.stringify(list)); } catch (_) { /* privater Modus */ }
    updateInquiryUI();
  }
  function inquiryCount(list) {
    return list.reduce(function (n, item) { return n + (item.qty || 1); }, 0);
  }
  // Preisformat der aktuellen Währung von Shopify übernehmen (window.EG.moneySample, z. B. „1.234,56 zł“)
  function formatMoney(cents) {
    var sample = (window.EG && window.EG.moneySample) || '';
    var m = sample.match(/1(\D?)234(\D)56/);
    var parts = (cents / 100).toFixed(2).split('.');
    if (!m) return parts.join(',');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, m[1]);
    return sample.replace(m[0], whole + m[2] + parts[1]);
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function updateInquiryUI() {
    var n = inquiryCount(getInquiry());
    document.querySelectorAll('[data-inquiry-count]').forEach(function (el) { el.textContent = n; });
    window.dispatchEvent(new Event('eg:inquiry'));
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-inquiry-add]');
    if (!btn) return;
    e.preventDefault();   // Button auf Produktkarten liegt im Produktlink
    var form = btn.closest('form');
    var qtyInput = form && form.querySelector('[data-qty-input]');
    var qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
    var id = String(btn.dataset.variantId);
    var list = getInquiry();
    var item = list.find(function (i) { return i.id === id; });
    if (item) {
      item.qty += qty;
    } else {
      list.push({
        id: id,
        title: btn.dataset.title || '',
        variant: btn.dataset.variantTitle || '',
        url: btn.dataset.url || '#',
        image: btn.dataset.image || '',
        price: parseInt(btn.dataset.price, 10) || 0,
        qty: qty
      });
    }
    setInquiry(list);
    toast((window.EG && window.EG.t && window.EG.t.inquiryAdded) || '✓');
  });

  // Anfrageseite (sections/inquiry-list.liquid)
  var inquiryPage = document.querySelector('[data-inquiry-page]');
  if (inquiryPage) {
    var cfgEl = inquiryPage.querySelector('[data-inquiry-config]');
    var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { t: {} };
    var listEl = inquiryPage.querySelector('[data-inquiry-list]');
    var emptyEl = inquiryPage.querySelector('[data-inquiry-empty]');
    var footerEl = inquiryPage.querySelector('[data-inquiry-footer]');

    var buildMessage = function (list) {
      var lines = list.map(function (i) {
        return '- ' + i.qty + ' × ' + i.title + (i.variant ? ' (' + i.variant + ')' : '') +
          ': ' + formatMoney(i.price * i.qty) + '\n  ' + cfg.origin + i.url;
      });
      var sum = list.reduce(function (s, i) { return s + i.price * i.qty; }, 0);
      return cfg.t.messageIntro + '\n\n' + lines.join('\n') + '\n\n' +
        cfg.t.messageSum + ': ' + formatMoney(sum) + '\n' +
        cfg.t.messageCountry + ': ' + cfg.country + '\n\n' + cfg.t.messageFields;
    };

    var renderInquiry = function () {
      var list = getInquiry();
      var empty = list.length === 0;
      emptyEl.hidden = !empty;
      listEl.hidden = empty;
      footerEl.hidden = empty;
      if (empty) { listEl.innerHTML = ''; return; }

      listEl.innerHTML = list.map(function (i) {
        return '<div class="inquiry__item" data-inquiry-item="' + escapeHtml(i.id) + '">' +
          (i.image ? '<a href="' + escapeHtml(i.url) + '"><img src="' + escapeHtml(i.image) + '" alt="" class="inquiry__img" loading="lazy"></a>' : '<span class="inquiry__img"></span>') +
          '<div class="inquiry__info">' +
            '<a href="' + escapeHtml(i.url) + '" class="inquiry__title">' + escapeHtml(i.title) + '</a>' +
            (i.variant ? '<div class="inquiry__variant">' + escapeHtml(i.variant) + '</div>' : '') +
            '<div class="inquiry__price">' + escapeHtml(formatMoney(i.price)) + '</div>' +
          '</div>' +
          '<div class="qty-input inquiry__qty" aria-label="' + escapeHtml(cfg.t.qty) + '">' +
            '<button type="button" data-inquiry-qty="-1" aria-label="−">−</button>' +
            '<input type="number" min="1" value="' + i.qty + '" data-inquiry-qty-input aria-label="' + escapeHtml(cfg.t.qty) + '">' +
            '<button type="button" data-inquiry-qty="1" aria-label="+">+</button>' +
          '</div>' +
          '<div class="inquiry__line">' + escapeHtml(formatMoney(i.price * i.qty)) + '</div>' +
          '<button type="button" class="inquiry__remove link-underline" data-inquiry-remove>' + escapeHtml(cfg.t.remove) + '</button>' +
        '</div>';
      }).join('');

      var sum = list.reduce(function (s, i) { return s + i.price * i.qty; }, 0);
      inquiryPage.querySelector('[data-inquiry-sum]').textContent = formatMoney(sum);

      var message = buildMessage(list);
      var wa = inquiryPage.querySelector('[data-inquiry-whatsapp]');
      if (wa) {
        if (cfg.wa) { wa.hidden = false; wa.href = 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(message); }
        else wa.hidden = true;
      }
      var mail = inquiryPage.querySelector('[data-inquiry-email]');
      if (mail) {
        mail.href = 'mailto:' + cfg.email + '?subject=' + encodeURIComponent(cfg.t.messageSubject) +
          '&body=' + encodeURIComponent(message);
      }
    };

    var changeQty = function (id, qty) {
      var list = getInquiry();
      var item = list.find(function (i) { return i.id === id; });
      if (!item) return;
      item.qty = Math.max(1, qty || 1);
      setInquiry(list);
    };
    inquiryPage.addEventListener('click', function (e) {
      var row = e.target.closest('[data-inquiry-item]');
      if (!row) return;
      var id = row.dataset.inquiryItem;
      var qtyBtn = e.target.closest('[data-inquiry-qty]');
      if (qtyBtn) {
        var input = row.querySelector('[data-inquiry-qty-input]');
        changeQty(id, parseInt(input.value, 10) + parseInt(qtyBtn.dataset.inquiryQty, 10));
      }
      if (e.target.closest('[data-inquiry-remove]')) {
        setInquiry(getInquiry().filter(function (i) { return i.id !== id; }));
      }
    });
    inquiryPage.addEventListener('change', function (e) {
      var input = e.target.closest('[data-inquiry-qty-input]');
      if (!input) return;
      changeQty(input.closest('[data-inquiry-item]').dataset.inquiryItem, parseInt(input.value, 10));
    });
    window.addEventListener('eg:inquiry', renderInquiry);
    renderInquiry();
  }
  updateInquiryUI();
  window.addEventListener('pageshow', function (e) { if (e.persisted) updateInquiryUI(); });
  // Änderungen aus einem anderen Tab übernehmen
  window.addEventListener('storage', function (e) { if (e.key === INQUIRY_KEY) updateInquiryUI(); });

  // ---- Announcement ticker ----
  var ticker = document.querySelector('[data-announce] .announce__messages');
  if (ticker) {
    var items = ticker.querySelectorAll('li');
    var idx = 0;
    setInterval(function () {
      items[idx].removeAttribute('aria-current');
      idx = (idx + 1) % items.length;
      items[idx].setAttribute('aria-current', 'true');
    }, 4000);
  }

  // ---- Collection filter auto-submit ----
  document.addEventListener('change', function (e) {
    var form = e.target.closest('#CollectionFiltersForm');
    if (!form) return;
    if (e.target.tagName === 'SELECT' || e.target.type === 'checkbox') {
      form.submit();
    }
  });

  // ---- Search pill fill ----
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-fill]');
    if (pill) {
      var input = document.querySelector('[data-search-modal] input[name="q"]');
      if (input) {
        input.value = pill.dataset.fill;
        input.focus();
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  });

  // ---- Predictive search (live results in the search modal) ----
  var searchModal = document.querySelector('[data-search-modal]');
  if (searchModal) {
    var searchInput = searchModal.querySelector('input[name="q"]');
    var searchResults = searchModal.querySelector('[data-search-results]');
    var searchTimer = null;
    var searchController = null;

    function runPredictiveSearch() {
      var q = searchInput.value.trim();
      if (searchController) searchController.abort();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchController = new AbortController();
      var params = new URLSearchParams({
        q: q,
        'resources[type]': 'product',
        'resources[limit]': '6',
        section_id: 'predictive-search'
      });
      fetch(searchModal.dataset.predictiveUrl + '?' + params.toString(), { signal: searchController.signal })
        .then(function (r) {
          if (!r.ok) throw new Error('Predictive search failed: ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.getElementById('shopify-section-predictive-search');
          searchResults.innerHTML = section ? section.innerHTML : '';
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') searchResults.innerHTML = '';
        });
    }

    if (searchInput && searchResults) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(runPredictiveSearch, 250);
      });
    }
  }

  // ---- Shelf scroll arrows ----
  function updateShelfArrows(track) {
    var wrap = track.closest('.shelf-scroll');
    if (!wrap) return;
    var prev = wrap.querySelector('.shelf-arrow--prev');
    var next = wrap.querySelector('.shelf-arrow--next');
    var atStart = track.scrollLeft <= 4;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    if (prev) prev.hidden = atStart;
    if (next) next.hidden = atEnd;
  }

  function initShelf(track) {
    updateShelfArrows(track);
    track.addEventListener('scroll', function () { updateShelfArrows(track); }, { passive: true });
  }
  document.querySelectorAll('.product-shelf__track').forEach(initShelf);

  // ---- Gleicher Duft (Produktseite): Produkte mit demselben Duftnummer-Tag nachladen ----
  document.querySelectorAll('[data-same-scent]').forEach(function (section) {
    fetch(section.dataset.url + '?section_id=product-same-scent')
      .then(function (r) {
        if (!r.ok) throw new Error('Same scent failed: ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var shelf = doc.querySelector('[data-same-scent-shelf]');
        if (!shelf) return;
        var current = shelf.querySelector('[data-item-id="' + section.dataset.exclude + '"]');
        if (current) current.remove();
        if (!shelf.querySelector('[data-item-id]')) return; // kein anderes Produkt mit dem Duft
        section.querySelector('[data-same-scent-items]').replaceWith(shelf);
        section.hidden = false;
        initShelf(shelf.querySelector('.product-shelf__track'));
        updateWishUI();
      })
      .catch(function () { /* Bereich bleibt ausgeblendet */ });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-shelf-arrow]');
    if (!btn) return;
    var track = btn.closest('.shelf-scroll').querySelector('.product-shelf__track');
    if (!track) return;
    track.scrollBy({ left: track.clientWidth * 0.75 * Number(btn.dataset.shelfArrow), behavior: 'smooth' });
  });

  // ---- Toast ----
  var toastTimer = null;
  function toast(message) {
    var el = document.querySelector('[data-toast]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('data-toast', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2200);
  }

  // ---- Share (Web Share API with copy-link fallback) ----
  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        ok ? resolve() : reject();
      } catch (err) { reject(err); }
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    e.preventDefault();
    var title = btn.dataset.shareTitle || document.title;
    var url   = btn.dataset.shareUrl || window.location.href;
    var copied = btn.dataset.toastCopied || 'Link kopiert';
    var failed = btn.dataset.toastFailed || 'Link konnte nicht kopiert werden';
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        copyToClipboard(url).then(function () { toast(copied); }, function () { toast(failed); });
      });
    } else {
      copyToClipboard(url).then(function () { toast(copied); }, function () { toast(failed); });
    }
  });
})();
